import React, { useEffect, useState } from 'react';
import { getCustomerLabel } from '../utils/customerCache';
import { getFeatures } from '../utils/featuresCache';

// #90/#102: Ticket-Einträge zeigen bei zugeordnetem Kunden dessen Kurzform fett
// und den Ticket-Titel in normaler Schrift darunter; ohne Kunden (oder bei
// deaktiviertem Kunden-Feature) bleibt der Titel wie bisher.
// titleStyle ist der bisherige Inline-Style des fetten Titel-Blocks der
// jeweiligen Kalenderansicht — beide Zeilen erben ihn, die Titel-Zeile
// bekommt nur das Gewicht herausgenommen. Listen-Ansichten (#102) übergeben
// stattdessen ihre bisherige Titel-CSS-Klasse als titleClassName.
function useCustomerLabel(customerId) {
  const [customerLabel, setCustomerLabel] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!customerId) {
      setCustomerLabel(null);
      return undefined;
    }
    getFeatures().then(features => {
      if (cancelled || features.customers === false) return;
      getCustomerLabel(customerId).then(label => {
        if (!cancelled) setCustomerLabel(label);
      });
    });
    return () => { cancelled = true; };
  }, [customerId]);

  return customerLabel;
}

// #103: eigenständige Kunden-Zeile (fett) für Karten ohne Titel-Umbau,
// z. B. Vorgangs-Karten — rendert nichts ohne Kunde/Feature.
export const CustomerLine = ({ customerId, className, style }) => {
  const customerLabel = useCustomerLabel(customerId);
  if (!customerLabel) return null;
  return <div className={className} style={style}>{customerLabel}</div>;
};

// #203: showContact (Opt-in, nur ui/TicketCard) hängt den Ansprechpartner in
// normaler Schrift an die fette Kundenzeile an („Kunde · Ansprechpartner",
// Option a aus der Klärung 2026-08-27) — das feste 4-Zeilen-Raster (#121/#187)
// bleibt unangetastet. Datenquelle ist das seit #200 mitgelieferte
// `contactName` am Ticket; fehlt es (ältere Cache-Stände), erscheint nichts —
// keine Platzhalter, kein Trennzeichen ins Leere.
const CalendarTicketTitle = ({ ticket, titleStyle, titleClassName, showContact = false }) => {
  const customerLabel = useCustomerLabel(ticket?.customerId);

  if (!customerLabel) {
    return <div className={titleClassName} style={titleStyle}>{ticket.title}</div>;
  }
  const contactName = showContact && ticket?.contactId ? (ticket?.contactName || null) : null;
  return (
    <>
      <div className={titleClassName} style={{ ...titleStyle, fontWeight: 'bold' }}>
        {customerLabel}
        {contactName && <span style={{ fontWeight: 'normal' }}> · {contactName}</span>}
      </div>
      <div className={titleClassName} style={{ ...titleStyle, fontWeight: 'normal', marginTop: 0, opacity: 0.95 }}>
        {ticket.title}
      </div>
    </>
  );
};

export default CalendarTicketTitle;
